export default {
  title: {
    id: 'bo_sellers-orders-drawers-order_recap-order_line_items-title',
    defaultMessage: 'Order line items',
  },
  lineItemNumber: {
    id: 'bo_sellers-orders-drawers-order_recap-order_line_items-line_item_number',
    defaultMessage: 'Line item #',
  },
  sku: {
    id: 'bo_sellers-orders-drawers-order_recap-order_line_items-sku',
    defaultMessage: 'SKU',
  },
  item: {
    id: 'bo_sellers-orders-drawers-order_recap-order_line_items-item',
    defaultMessage: 'Item',
  },
  quantity: {
    id: 'bo_sellers-orders-drawers-order_recap-order_line_items-quantity',
    defaultMessage: 'Quantity',
  },
  imeiOrSerialNumber: {
    id: 'bo_sellers-orders-drawers-order_recap-order_line_items-imei_or_serial_number',
    defaultMessage: 'IMEI/Serial #',
  },
  grade: {
    id: 'bo_sellers-orders-drawers-order_recap-order_details-grade',
    defaultMessage: 'Grade',
  },
  appearance: {
    id: 'bo_sellers-orders-drawers-order_recap-order_details-appearance',
    defaultMessage: 'Appearance',
  },
  price: {
    id: 'bo_sellers-orders-drawers-order_recap-order_line_items-price',
    defaultMessage: 'Price',
  },
} as const
